import { FelaCSS, spacing } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  column: FelaCSS;
  copyToClipboardButton: FelaCSS;
}

const styles = (): IStyles => ({
  wrapper: {
    flexDirection: 'row',
    paddingBottom: 6,

    maxWidthTabletSm: {
      flexDirection: 'column',
    },
    minWidthTabletLg: {
      paddingTop: 2,
    },
  },

  column: {
    width: '50%',
    paddingLeft: 3,
    gap: spacing[6],

    maxWidthTabletSm: {
      width: '100%',
      paddingLeft: 0,
    },

    ':first-of-type': {
      paddingLeft: 0,
      paddingRight: 3,

      maxWidthTabletSm: {
        marginBottom: 6,
        paddingRight: 0,
      },
    },
  },

  copyToClipboardButton: {
    paddingLeft: 2,
  },
});

export default styles;
